export const CALCULATOR_LOAD_LAST_CALCULATION_DATA = 'CALCULATOR_LOAD_LAST_CALCULATION_DATA';
export const CALCULATOR_DROP_LAST_CALCULATION_DATA = 'CALCULATOR_DROP_LAST_CALCULATION_DATA';
export const CALCULATOR_SET_SELECTED_PROGRAM_ID = 'CALCULATOR_SET_SELECTED_PROGRAM_ID';

export const CALCULATOR_APPROVAL = 'CALCULATOR_APPROVAL';
export const CALCULATOR_PICKER_LOG = 'CALCULATOR_PICKER_LOG';
